import React, { useEffect, useState } from "react";
import { Box, TextField, Typography } from "@mui/material";

const Row = ({ item, onValueChange, isStandardCredit = false }) => {
  const [count, setCount] = useState(item.value || "");

  useEffect(() => {
    if (count === "" || item.id) {
      setCount(item.value || "");
    }
  }, [item.id, item.value]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (e) => {
    const newCount = parseInt(e.target.value) || 0;
    setCount(newCount === 0 ? "" : newCount);
    isStandardCredit ? onValueChange(newCount, 7) : onValueChange(newCount, item.id);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: { xs: 1.5, md: 2 },
        padding: { xs: '2%', md: '1.5%' },
        background: 'transparent',
        position: 'relative',
        overflow: 'visible',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
      }}
      className="animate-scale-in"
    >
      <Box
        sx={{
          position: 'relative',
          display: 'inline-block',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '24vw', md: '18vw' },
            height: { xs: '24vw', md: '18vw' },
            maxWidth: '11rem',
            maxHeight: '11rem',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(255, 215, 0, 0.3) 0%, transparent 70%)',
            animation: 'pulse-glow 2s ease-in-out infinite',
            pointerEvents: 'none',
          }}
        />
        <img
          src={`/img/items-icons/${item.name || "standardCredits"}.png`}
          alt={item.name || "Standard Credit"}
          className="animate-float"
          style={{
            width: 'clamp(6rem, 20vw, 9rem)',
            height: 'clamp(6rem, 20vw, 9rem)',
            borderRadius: "50%",
            border: "0.25rem solid rgba(218, 165, 32, 0.7)",
            padding: "0.5rem",
            background: 'linear-gradient(135deg, rgba(255, 215, 0, 0.2) 0%, rgba(218, 165, 32, 0.3) 100%)',
            boxShadow: '0 0 1.5rem rgba(218, 165, 32, 0.6), 0 0.4rem 1.2rem rgba(0, 0, 0, 0.7)',
            filter: 'drop-shadow(0 0.25rem 0.8rem rgba(218, 165, 32, 0.5))',
            position: 'relative',
            zIndex: 1,
          }}
        />
      </Box>

      <Typography
        variant="h5"
        sx={{
          color: "#FFD700",
          fontWeight: 700,
          fontSize: { xs: '2rem', md: '1.5rem' },
          fontFamily: "'Philosopher', sans-serif",
          textShadow: '0.15rem 0.15rem 0.3rem rgba(0,0,0,0.9), 0 0 0.8rem rgba(255, 215, 0, 0.6)',
          px: { xs: '5%', md: '3%' },
          lineHeight: 1.3,
          wordWrap: 'break-word',
          overflowWrap: 'break-word',
          hyphens: 'auto',
          width: '100%',
        }}
      >
        {isStandardCredit
          ? "Standard Credits"
          : `How many ${item.name} you have?`}
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: isStandardCredit ? "center" : "space-between",
          alignItems: "center",
          width: "100%",
          maxWidth: '100%',
          gap: { xs: 1, md: 2 },
          flexWrap: 'nowrap',
          px: { xs: '3%', md: '2%' },
        }}
      >
        <TextField
          sx={{
            flex: isStandardCredit ? 1 : 'none',
            width: isStandardCredit ? '100%' : 'auto',
            minWidth: { xs: isStandardCredit ? '100%' : '10rem', md: '12rem' },
            maxWidth: isStandardCredit ? '100%' : { xs: '11rem', md: 'none' },
            "& .MuiInputBase-root": {
              fontSize: { xs: "1.25rem", md: "1.25rem" },
              height: { xs: "3.75rem", md: "3.5rem" },
              background: 'rgba(255, 255, 255, 0.98)',
              borderRadius: '0.75rem',
              fontFamily: "'Cinzel', serif",
              fontWeight: 700,
              transition: 'all 0.3s ease',
              '&:hover': {
                background: 'rgba(255, 255, 255, 1)',
                boxShadow: '0 0 1.25rem rgba(218, 165, 32, 0.4)',
              },
              '&.Mui-focused': {
                boxShadow: '0 0 1.5rem rgba(218, 165, 32, 0.6)',
              }
            },
            "& .MuiInputLabel-root": {
              fontSize: { xs: "0.95rem", md: "0.9rem" },
              fontFamily: "'Philosopher', sans-serif",
              fontWeight: 700,
              color: 'rgba(139, 69, 19, 0.9)',
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: 'rgba(218, 165, 32, 0.6)',
              borderWidth: '0.2rem',
            },
            "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: 'rgba(218, 165, 32, 0.9)',
            },
            "& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: 'rgba(218, 165, 32, 1)',
              borderWidth: '0.2rem',
            }
          }}
          type="number"
          label={
            isStandardCredit
              ? "Enter Standard Credits"
              : `Enter ${item.name}`
          }
          placeholder={
            isStandardCredit
              ? "0"
              : "0"
          }
          value={count}
          onChange={handleChange}
          size="medium"
          variant="outlined"
        />

        {!isStandardCredit && (
          <>
            <Typography
              sx={{
                fontWeight: 900,
                fontSize: { xs: "1.75rem", md: "2rem" },
                fontFamily: "'Cinzel', serif",
                color: "#FFD700",
                textShadow: '0.2rem 0.2rem 0.4rem rgba(0,0,0,0.9), 0 0 0.75rem rgba(255, 215, 0, 0.7)',
                padding: { xs: '0.25rem 0.5rem', md: '0.5rem 0.75rem' },
                background: 'transparent',
                borderRadius: '0.75rem',
                flexShrink: 0,
              }}
            >
              ×{item?.multiplier}
            </Typography>
            <Box
              sx={{
                minWidth: { xs: '5.5rem', md: '7rem' },
                maxWidth: { xs: '6.5rem', md: '8.5rem' },
                textAlign: 'center',
                padding: { xs: '0.75rem 1rem', md: '0.75rem 1.25rem' },
                background: 'linear-gradient(135deg, rgba(218, 165, 32, 0.4) 0%, rgba(184, 134, 11, 0.3) 100%)',
                borderRadius: { xs: '0.75rem', md: '1rem' },
                border: '0.2rem solid rgba(255, 215, 0, 0.6)',
                boxShadow: '0 0 1.5rem rgba(218, 165, 32, 0.5), inset 0 0.15rem 0 rgba(255, 255, 255, 0.25)',
                flexShrink: 0,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 900,
                  fontSize: { xs: "1.75rem", md: "2rem" },
                  fontFamily: "'Cinzel', serif",
                  color: '#FFF',
                  textShadow: '0.25rem 0.25rem 0.5rem rgba(0,0,0,0.9), 0 0 1.25rem rgba(255, 215, 0, 1)',
                  background: 'linear-gradient(180deg, #FFD700 0%, #FFA500 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  filter: 'drop-shadow(0 0.2rem 0.35rem rgba(0,0,0,0.6))',
                  lineHeight: 1,
                }}
                className="animate-count-up"
              >
                {count * item?.multiplier}
              </Typography>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Row;
